import axios from 'axios';
/**
 * Fetch the config.json file which contains the configuration
 *
 * @returns {Object} config object
 */
export function fetchEnv() {
  const path =
    process.env.NODE_ENV === 'development'
      ? `${window.location.origin}/src/assets/config/config.json`
      : `${window.location.origin}/assets/config.json`;

  return new Promise<any>((resolve, reject) => {
    axios
      .get(path)
      .then(environnement => {
        resolve(environnement.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
